

export function communityPostListGet(page) {
	return {
    type: 'COMMUNITY_POST_LIST_GET',
		payload: {
			page: page,
		},
	}
}


export const communityPostItemEdit = (postId, goodCount, goodSended) => {
	return {
		type: "COMMUNITY_POST_ITEM_EDIT",
		payload: {
			postId: postId,
			goodCount: goodCount,
			goodSended: goodSended,
		},
	}
}

export function communityPostScrollposEdit(scrollpos) {
	return {
    type: 'COMMUNITY_POST_SCROLLPOS_SET',
		payload: {
			scrollpos: scrollpos,
		},
	}
}
